import React from 'react'
import { IonItem, IonLabel, IonToggle, IonButton, IonIcon } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { chevronForward, chevronDown } from 'ionicons/icons'
import { ICategory } from '../store/specialReports.types'
import { IOption } from '../../../common/common.types'

interface CategoryItemProps {
  category: ICategory
  subCategories: ICategory[]
  isSelected: boolean
  isExpanded: boolean
  selectedSubCategories: IOption[]
  isCategoryDisabled?: boolean
  onCategoryToggle: (category: ICategory) => void
  onExpandToggle: (categoryId: string) => void
  onSubCategoryToggle: (subCategory: ICategory, checked: boolean) => void
}

const CategoryItem: React.FC<CategoryItemProps> = ({
  category,
  subCategories,
  isSelected,
  isExpanded,
  selectedSubCategories,
  isCategoryDisabled = false,
  onCategoryToggle,
  onExpandToggle,
  onSubCategoryToggle,
}) => {
  const { t } = useTranslation()
  const hasSubCategories = subCategories.length > 0
  const categoryId = category.elementId

  const isSubCategorySelected = (subCategoryId: string): boolean => {
    return selectedSubCategories.some((sub) => sub.id === Number(subCategoryId))
  }

  return (
    <>
      <IonItem lines='none'>
        <IonToggle
          slot='start'
          checked={isSelected}
          disabled={isCategoryDisabled}
          onClick={() => !isCategoryDisabled && onCategoryToggle(category)}
          color='zoll-blue-secondary'
        />
        <IonLabel>{category.label}</IonLabel>
        {isSelected && hasSubCategories && (
          <IonButton fill='clear' size='small' onClick={() => onExpandToggle(categoryId)} slot='end'>
            <IonLabel className='font-weight-bold'>{t('specialReports.subType')}</IonLabel>
            <IonIcon icon={isExpanded ? chevronDown : chevronForward} slot='end' />
          </IonButton>
        )}
      </IonItem>

      {isSelected && hasSubCategories && isExpanded && (
        <>
          {subCategories.map((subCategory) => (
            <IonItem
              key={subCategory.elementId}
              lines='none'
              style={{ '--padding-start': '2rem' } as React.CSSProperties}>
              <IonToggle
                slot='start'
                checked={isSubCategorySelected(subCategory.elementId)}
                onIonChange={(e) => onSubCategoryToggle(subCategory, e.detail.checked)}
                color='zoll-blue-secondary'
              />
              <IonLabel>{subCategory.label}</IonLabel>
            </IonItem>
          ))}
        </>
      )}
    </>
  )
}

export default CategoryItem
